<template>
  <div class="tw-flex tw-items-center tw-gap-2 tw-p-4 tw-border-b tw-border-border">
    <button class="tw-p-2 tw-rounded-md hover:tw-bg-muted" @click="openMenu">
      <Menu class="tw-w-6 tw-h-6" />
    </button>
    <img src="/assets/vitable-logo.png" alt="logo" class="tw-h-8" />
  </div>

  <div v-if="isMenuOpen" class="tw-fixed tw-inset-0 tw-z-50 tw-bg-card tw-flex tw-flex-col">
    <div class="tw-flex tw-items-center tw-justify-between tw-p-4 tw-border-b tw-border-border">
      <img src="/assets/vitable-logo.png" alt="logo" class="tw-h-8" />
      <button class="tw-p-2 tw-rounded-md hover:tw-bg-muted" @click="closeMenu">
        <X class="tw-w-6 tw-h-6" />
      </button>
    </div>

    <div class="tw-flex tw-flex-col tw-flex-1 tw-p-4">
      <DashboardNavItems @navigate="handleNavigate" />

      <div class="tw-mt-auto tw-pt-4">
        <DashboardUserProfile @logout="closeMenu" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue"
import { Menu, X } from "lucide-vue-next"
import DashboardNavItems from "./DashboardNavItems.vue"
import DashboardUserProfile from "./DashboardUserProfile.vue"

const isMenuOpen = ref(false)

function openMenu() {
  isMenuOpen.value = true
}

function closeMenu() {
  isMenuOpen.value = false
}

function handleNavigate() {
  closeMenu()
}
</script>
